import { Controller } from '@hotwired/stimulus'

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'logo',
        'container',
    ]

    connect() {
        this._desktopQuery = window.matchMedia('(min-width: 768px)')
        this._onResize = this.updateHeight.bind(this)

        this.updateHeight()
        window.addEventListener('resize', this._onResize)
    }

    disconnect() {
        window.removeEventListener('resize', this._onResize)
    }

    updateHeight() {
        if (!this._desktopQuery.matches) {
            this.containerTarget.style.height = ''
            return
        }

        const parentHeight = this.element.clientHeight
        const logoHeight = this.logoTarget.offsetHeight
        this.containerTarget.style.height = `${parentHeight - logoHeight}px`
    }
}
